var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tools-container",attrs:{"id":("tools-container-" + (_vm.eventSlot.index))}},_vm._l((_vm.slotTools),function(tool){return _c('div',{key:("tool-" + (tool.icon)),staticClass:"tool-button",attrs:{"id":("tool-" + (tool.name))}},[_c('b-icon',{style:({
				'color': _vm.slotIconColor
			}),attrs:{"icon":tool.icon,"custom-size":"mdi-18px"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }